const download = (blob, file) => {
	const downloadLink = document.createElement("a");
	downloadLink.href = URL.createObjectURL(blob);
	downloadLink.download = file;
	downloadLink.click();
	URL.revokeObjectURL(downloadLink.href);
};
export default download;